
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class AccordionBox extends Vue {
  @Prop({ default: '' }) title!: string;

  @Prop({ default: undefined }) open?: boolean | string;

  @Prop({ default: false }) lazy?: boolean | string;

  @Prop({ default: true }) toggleable?: boolean;

  private isOpen: boolean = false;

  @Watch('open', { immediate: true })
  onOpenChange() {
    this.isOpen = this.open !== false;
  }

  toggleOpen(open?: boolean) {
    if (this.toggleable !== false) {
      const value = open !== undefined ? open : !this.isOpen;
      this.isOpen = value;
      this.$emit('update:open', value);
    }
  }
}
